import SliceType from '../constants/sliceType';
import get from '../helpers/get';
import { getSlices } from './content';

export const getSponsoredBrandProductsSlices = state => {
  const slices = getSlices(state);
  return slices.filter(
    slice => slice.type === SliceType.SPONSORED_BRAND_PRODUCTS,
  );
};

export const getSponsoredBrandWithSliceId = (state, sliceId) => {
  const slices = getSponsoredBrandProductsSlices(state);
  const sliceIndex = slices.findIndex(slice => slice.sliceId === sliceId);
  if (sliceIndex < 0) {
    return null;
  };

  const sponsoredBrand = get(state, [
    'sponsoredBrands',
    'sponsoredBrands',
    sliceIndex,
  ]);
  if (!sponsoredBrand) {
    return null;
  };

  const brandInfo = get(state, ['favouritedBrands', 'favouritedBrands', sponsoredBrand.brandId]);
  return {
    id: sponsoredBrand.id,
    brandId: sponsoredBrand.brandId,
    brandName: sponsoredBrand.brandName,
    headline: sponsoredBrand.headline,
    description: sponsoredBrand.description,
    ctaText: sponsoredBrand.ctaText,
    ctaLinkUrl: sponsoredBrand.ctaLinkUrl,
    colorScheme: sponsoredBrand.colorScheme,
    mediaAssets: sponsoredBrand.mediaAssets,
    products: sponsoredBrand.products,
    status: brandInfo?.status || false,
    busy: brandInfo?.busy || false,
    error: brandInfo?.error || null,
  };
};
